import { FC } from 'react';
import { GetServerSideProps } from 'next';
import { dehydrate } from 'react-query';
import Footer from '@common/footer';
import Content from '@components/common/content';
import { CompanyChannelCustomHead } from '@components/common/customHead';
import Header from '@components/common/header';
import Layout from '@components/common/layout';
import CompanyDetail from '@components/company/sn';
import {
  fetchCompaniesInformation,
  getCompaniesInformationKeys,
  useCompaniesInformation,
} from '@repository/companies/useCompanies';
import { queryClient } from '@utils/queryClient';

interface InfoProps {
  companySn: number;
}

const Info: FC<InfoProps> = ({ companySn }) => {
  const { data: companyInfoData } = useCompaniesInformation(companySn);

  return (
    <Layout>
      {companyInfoData && <CompanyChannelCustomHead metaData={companyInfoData} />}
      <Header />
      <Content>
        <CompanyDetail />
      </Content>
      <Footer />
    </Layout>
  );
};

export default Info;

export const getServerSideProps: GetServerSideProps = async ({ query }) => {
  const companySn = isNaN(Number(query.sn)) ? 0 : Number(query.sn);
  await queryClient.prefetchQuery(getCompaniesInformationKeys(companySn), () => fetchCompaniesInformation(companySn));

  return {
    props: {
      companySn,
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
    },
  };
};
